import React from "react";
import "./customToolTip.css";

function CustomToolTip({ label, customClass, children }) {
  return (
    <div className="root">
      <div className={`custom_tooltip_children ${customClass}`}>
        {label && <p className="custom_tooltip">{label}</p>}
        {children}
      </div>
    </div>
  );
}

export default CustomToolTip;
